"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TempTestWalletPOIRequester = void 0;
class TempTestWalletPOIRequester {
    // eslint-disable-next-line class-methods-use-this
    async validateRailgunTxidMerkleroot(chain, tree, index, merkleroot) {
        return true;
    }
    // eslint-disable-next-line class-methods-use-this
    async getLatestValidatedRailgunTxid(chain) {
        return { txidIndex: 100000, merkleroot: undefined };
    }
}
exports.TempTestWalletPOIRequester = TempTestWalletPOIRequester;
